import { AfterViewInit, ChangeDetectorRef, Component, Input, ViewEncapsulation } from "@angular/core";
import { IMenu } from "../../types/menu";
import { OpMenuItem } from "../opMenuItem/opMenuItem.component";


@Component({
    selector: 'op-main-menu',
    templateUrl: "./opMainMenu.view.html",
    styleUrls: ["./opMainMenu.style.scss"],
    encapsulation: ViewEncapsulation.None,
    imports: [OpMenuItem]
})
export class OpMainMenu implements AfterViewInit {

  @Input() sections: IMenu[];
  @Input() menuAccordionMode: boolean = false;
  @Input() menuFixedFirstLevel: boolean = false;

  constructor(private _cd: ChangeDetectorRef) {}

  ngAfterViewInit() {
    this._cd.detectChanges();
  }
}
